// Paints the border box with the promotional gradient while the padding box keeps the field fill.
// Avoids pseudo-elements so absolutely positioned field children keep their own stacking.
export default (theme, fillColor = theme.colors.actionMinor[50]) => ({
    border: '1px solid transparent',
    backgroundColor: theme.colors.transparent,
    background: `linear-gradient(${fillColor}, ${fillColor}) padding-box, linear-gradient(to right, ${theme.colors.utility.promoGradientGreen}, ${theme.colors.utility.promoGradientBlue}, ${theme.colors.utility.promoGradientPurple}) border-box`,
});
